import React, {Component} from 'react';
import {UncontrolledTooltip} from "reactstrap";
import SquareButton from "../../../components/SquareButton";
import {validateComponent, validateField} from "../../../common/validation";
import {deepCopyObject} from "../../../helper/helper";
import Alert from "react-s-alert";
import _ from 'lodash';
import moment from "moment";

class UserGeneralInfo extends Component {

	constructor(props) {
		super(props);

		this.state = {
			mode: 'generalBrowse',
			error: {},
			addDraftWatermark: false,
			completeUser:{},
			currentCustomer:{},
			isMobile : window.innerWidth > 991 ? false : true
		};

		this.validateClass = this.validateClass.bind(this);
		this.validateComponent = this.validateComponent.bind(this);
		this.validateField = this.validateField.bind(this);
		this.validateMessage = this.validateMessage.bind(this);
		this.switchToEditMode = this.switchToEditMode.bind(this);
		this.saveUser = this.saveUser.bind(this);
		this.onAddDraftWatermarkChange = this.onAddDraftWatermarkChange.bind(this);
	}

	componentWillReceiveProps(nextProps, nextContext) {
		if (nextProps && nextProps.completeUser)
			this.setState({completeUser: nextProps.completeUser});

		if (nextProps && nextProps.currentCustomer)
			this.setState({currentCustomer: nextProps.currentCustomer});
	}

	validateField(e) {
		let id = e.target.id;
		let rule = e.target.dataset.vdata;
		let boundary = e.target.dataset.vlength;
		let result = validateField(rule, boundary, e.target.value);
		let error = this.state.error;
		error = Object.assign(error, {[id]: result});
		this.setState({error});
	}

	validateClass(id) {
		let error = this.state.error;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let error = this.state.error;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	validateComponent() {
		let result = validateComponent(this);
		this.setState({
			error: result.error
		});
		return result
	}

	saveUser() {
		let generalInfoValidity = this.validateComponent();
		if (generalInfoValidity.valid) {
			let completeUser = deepCopyObject(this.state.completeUser)

			let finalState = {};
			finalState.firstName = completeUser.firstName;
			finalState.lastName = completeUser.lastName;
			finalState.username = completeUser.username;
			finalState.email = completeUser.email;
			finalState.addDraftWatermark = completeUser.addDraftWatermark;

			if (!_.isEqual(this.props.initState, finalState)) {
				this.props.handleSubmit();
				this.setState({mode: 'generalBrowse'})
			} else {
				Alert.warning('Herhangi bir değişiklik yapmadınız', {
					html: true,
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				});
				this.setState({mode: 'generalBrowse'})
			}
		} else {
			Alert.error('Zorunlu alanlari doldurunuz', {
				html: true,
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000
			})
		}
	}

	switchToEditMode() {
		this.setState({mode: 'generalEdit'})
	}

	onAddDraftWatermarkChange(e) {
		this.setState({addDraftWatermark: this.state.completeUser.addDraftWatermark ? 0 : 1});
		e.target.value = this.state.completeUser.addDraftWatermark ? 0 : 1;
		this.props.onChangeGeneralInfo(e);
	}

	render() {
		const{ isMobile } = this.state;
		return (
			<div>


				<div className="col-sm-12 row" style={{margin: '30px 0 30px 0'}}>
					<div className="col sm-12">
						<div className="col-sm-5">
							<label className="col-form-label" style={{fontWeight: 'bold'}}>Vkn/Tckn: </label>
						</div>
						<div className="col-sm-7">
							<label className="col-form-label">{this.state.currentCustomer && this.state.currentCustomer.vknTckn}</label>
						</div>
					</div>

					<div className="col sm-12">
						<div className="col-sm-5">
							<label className="col-form-label" style={{fontWeight: 'bold'}}>Unvan: </label>
						</div>
						<div className="col-sm-7">
							<label className="col-form-label">{this.state.currentCustomer && this.state.currentCustomer.formattedName}</label>
						</div>
					</div>
				</div>
				<div style={{padding: '0 15px 0 15px'}}>
					<hr/>
				</div>
				{!isMobile && <div className="col-sm-12" style={{textAlign: 'right'}}>
					<SquareButton title={this.state.mode === 'generalEdit' ? 'Kaydet' : 'Düzenle'}
								  img={this.state.mode === 'generalEdit' ? 'save.png' : 'edit.png'}
								  style={this.state.mode === 'generalEdit' ? {background: 'linear-gradient(rgba(135, 226, 146, 0.65), #3abf44)'} :
									  {background: 'linear-gradient(rgba(154, 193, 218, 0.61), #6e8da2)'}}
								  onClick={this.state.mode === 'generalEdit' ? this.saveUser : this.switchToEditMode}/>
				</div>}
				<div className="col-sm-12 row" style={{margin: '0 0 10px 0'}}>
					<div className="col sm-12">
						<div className="col-sm-5">
							<label className="col-form-label" style={{fontWeight: 'bold'}}>Ad: </label>
						</div>
						<div className="col-sm-7">
							{this.state.mode === 'generalBrowse' &&
							<label className="col-form-label">{this.state.completeUser && this.state.completeUser.firstName}</label>}

							{this.state.mode === 'generalEdit' &&
							<div className={"form-group" + this.validateClass('tFirstName')}>
								<input className="form-control"
									   type="text"
									   name="firstName"
									   id="tFirstName"
									   data-vlength="1,255"
									   data-vdata="required"
									   onBlur={this.validateField}
									   ref="tFirstName"
									   value={this.state.completeUser && this.state.completeUser.firstName}
									   onChange={(e) => this.props.onChangeGeneralInfo(e)}/>
								{this.validateMessage('tFirstName') !== "" &&
								<UncontrolledTooltip placement="right" target="tFirstName" delay={0}>
									{this.validateMessage("tFirstName")}
								</UncontrolledTooltip>}
							</div>}
						</div>
					</div>

					<div className="col sm-12">
						<div className="col-sm-5">
							<label className="col-form-label" style={{fontWeight: 'bold'}}>Soyad: </label>
						</div>
						<div className="col-sm-7">
							{this.state.mode === 'generalBrowse' &&
							<label className="col-form-label">{this.state.completeUser && this.state.completeUser.lastName}</label>}
							{this.state.mode === 'generalEdit' &&
							<div className={"form-group" + this.validateClass('tLastName')}>
								<input className="form-control"
									   type="text"
									   name="lastName"
									   id="tLastName"
									   data-vlength="1,255"
									   data-vdata="required"
									   onBlur={this.validateField}
									   ref="tLastName"
									   value={this.state.completeUser && this.state.completeUser.lastName}
									   onChange={(e) => this.props.onChangeGeneralInfo(e)}/>
								{this.validateMessage('tLastName') !== "" &&
								<UncontrolledTooltip placement="right" target="tLastName" delay={0}>
									{this.validateMessage("tLastName")}
								</UncontrolledTooltip>}
							</div>}
						</div>
					</div>
				</div>
				<div className="col-sm-12 row" style={{margin: '0 0 10px 0'}}>
					<div className="col sm-12">
						<div className="col-sm-5">
							<label className="col-form-label" style={{fontWeight: 'bold'}}>Kullanıcı Adı: </label>
						</div>
						<div className="col-sm-7">
							{this.state.mode === 'generalBrowse' &&
							<label className="col-form-label">{this.state.completeUser && this.state.completeUser.username}</label>}

							{this.state.mode === 'generalEdit' &&
							<div className={"form-group" + this.validateClass('tUsername')}>
								<input className="form-control"
									   type="text"
									   name="username"
									   id="tUsername"
									   disabled={false}
									   data-vlength="1,255"
									   data-vdata="required"
									   onBlur={this.validateField}
									   ref="tUsername"
									   value={this.state.completeUser && this.state.completeUser.username}
									   onChange={(e) => this.props.onChangeGeneralInfo(e)}/>
								{this.validateMessage('tUsername') !== "" &&
								<UncontrolledTooltip placement="right" target="tUsername" delay={0}>
									{this.validateMessage("tUsername")}
								</UncontrolledTooltip>}
							</div>}
						</div>
					</div>
					<div className="col sm-12">
						<div className="col-sm-5">
							<label className="col-form-label" style={{fontWeight: 'bold'}}>e-Posta: </label>
						</div>
						<div className="col-sm-7">
							{this.state.mode === 'generalBrowse' &&
							<label className="col-form-label">{this.state.completeUser && this.state.completeUser.email}</label>}
							{this.state.mode === 'generalEdit' &&
							<div className={"form-group" + this.validateClass('tEmail')}>
								<input className="form-control"
									   type="text"
									   name="email"
									   id="tEmail"
									   data-vlength="1,255"
									   data-vdata="email"
									   onBlur={this.validateField}
									   ref="tEmail"
									   value={this.state.completeUser && this.state.completeUser.email}
									   onChange={(e) => this.props.onChangeGeneralInfo(e)}/>
								{this.validateMessage('tEmail') !== "" &&
								<UncontrolledTooltip placement="right" target="tEmail" delay={0}>
									{this.validateMessage("tEmail")}
								</UncontrolledTooltip>}
							</div>}
						</div>
					</div>
				</div>

				<div className="col-lg-6 sm-12" style={{margin: '0 0 10px 0'}}>
					<div className="col lg-6 sm-12">
						<div className="col-sm-5">
							<label className="col-form-label" style={{fontWeight: 'bold'}}>Taslak Filigranı Eklensin mi? : </label>
						</div>
						<div className='col-sm-7 ml-1 d-flex align-items-center'>
							<input type="checkbox"
								   name="addDraftWatermark"
								   checked={this.state.completeUser && this.state.completeUser.addDraftWatermark}
								   onChange={this.onAddDraftWatermarkChange}
								   disabled={this.state.mode === 'generalBrowse'}/>
						</div>
					</div>
				</div>

				<div className="col-sm-12 row" style={{margin: '0 0 15px 0'}}>
					<div className="col sm-6">
						<button className='TekBtn edit ml-3'
								disabled={this.props.impersonateUserRoleId === 3 || this.props.impersonateUserRoleId === 4}
								onClick={this.props.openPreWarningForPasswordChange}> Şifre Değiştir
						</button>
					</div>

					<div className="col d-flex align-items-center">
						<div className="col-sm-5">
							<label className="col-form-label" style={{fontWeight: 'bold'}}>Son Şifre Değişiklik Tarihi:</label>
						</div>
						<div className="col-sm-7">
							{this.state.completeUser.passwordUpdatedAt ? moment(this.state.completeUser.passwordUpdatedAt).format('DD-MM-YYYY HH:mm:ss') : "-"}
						</div>
					</div>

					{ isMobile &&
						<div className="col-1 sm-4" style={{textAlign: 'right',height:'30px',alignItems:'center',justifyContent:'flex-end'}}>
							<SquareButton title={this.state.mode === 'generalEdit' ? 'Kaydet' : 'Düzenle'}
										  img={this.state.mode === 'generalEdit' ? 'save.png' : 'edit.png'}
										  style={this.state.mode === 'generalEdit' ? {background: 'linear-gradient(rgba(135, 226, 146, 0.65), #3abf44)'} :
											  {background: 'linear-gradient(rgba(154, 193, 218, 0.61), #6e8da2)'}}
										  onClick={this.state.mode === 'generalEdit' ? this.saveUser : this.switchToEditMode}/>
						</div>
					}
				</div>
			</div>
		)
	}
}

export default UserGeneralInfo;